import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import * as style from './ArticleImageQuoteBlock.module.scss';
import { getRelAttribute } from '../../../utilities';

/**
 * Quote block that also displays author's name, occupation and photo above the quote
 */
const ArticleImageQuoteBlock = (props) => {
  const {
    text,
    authorName,
    authorOccupation,
    authorImageData,
    linkUrl,
    isNoFollow,
    isNewTab,
  } = props;

  const linkTarget = isNewTab ? '_blank' : '_self';

  return (
    <div>
      <div className={style.contentWrapper}>
        <div className={style.authorSection}>
          {authorImageData && authorImageData?.images && (
            <GatsbyImage
              className={style.authorImage}
              image={authorImageData}
              alt={authorName}
              title={authorName}
              style={{ borderRadius: '50%' }}
            />
          )}
          <div>
            <div className={style.authorName}>{authorName}</div>
            {linkUrl ? (
              <a
                className={`${style.authorOccupation} clearLinkStyle`}
                href={linkUrl}
                title={authorOccupation}
                target={linkTarget}
                rel={getRelAttribute(linkTarget, isNoFollow)}
              >
                {authorOccupation}
              </a>
            ) : (
              <div className={style.authorOccupation}>{authorOccupation}</div>
            )}
          </div>
        </div>
        <div className={style.quote}>{text}</div>
      </div>
    </div>
  );
};

ArticleImageQuoteBlock.defaultProps = {
  isNewTab: false,
  isNoFollow: false,
  linkUrl: '',
};

ArticleImageQuoteBlock.propTypes = {
  /**
   * Text of the quote.
   */
  text: PropTypes.string.isRequired,
  /**
   * Author's name.
   */
  authorName: PropTypes.string.isRequired,
  /**
   * Author's occupation (e.g. skier, content creator).
   */
  authorOccupation: PropTypes.string.isRequired,
  /**
   * Author's image (gatsby-image data).
   */
  authorImageData: PropTypes.object.isRequired,
  /**
   * Optional link
   */
  linkUrl: PropTypes.string,
  /**
   * Whether the link is 'nofollow'
   */
  isNoFollow: PropTypes.bool,
  /**
   * Whether should open in a new tab
   */
  isNewTab: PropTypes.bool,
};

export default ArticleImageQuoteBlock;
